module.exports = __webpack_public_path__ + "media/images/game_icon/zh-cn/AB1007-03aa23136823b1a79e824bcac0b49867.png";